<template>
  <div class="search-wrap z-flex">
    <div class="search-item-wrap">
      <a-space>
        <a-input
          size="large"
          :value="query.workOrderId"
          placeholder="请输入工单ID"
          @input="inputR($event, 'workOrderId', 3)"
          allowClear
          :maxlength="19"
        />
        <a-input
          size="large"
          :value="query.serialNumber"
          placeholder="请输入处方ID"
          @input="inputR($event, 'serialNumber', 4)"
          allowClear
          :maxlength="19"
        />
      </a-space>
    </div>
    <div class="btn-item">
      <a-space>
        <a-button
          size="large"
          @click="emits('searchList', query)"
          class="search-btn"
          type="primary"
        >
          搜索
        </a-button>
        <a-button
          size="large"
          type="primary"
          @click="emits('handleExport', query)"
          class="search-export"
        >
          导出
        </a-button>
      </a-space>
    </div>
  </div>
</template>
<script setup>
import { reactive, defineEmits } from 'vue'
import { inputRule } from '@/utils/validate'
const emits = defineEmits(['searchList', 'handleExport'])

const query = reactive({
  workOrderId: null,
  serialNumber: null
})
function inputR(e, key, type) {
  query[key] = inputRule(e.target.value, type) || null
}
</script>
<style scoped lang="scss">
.search-item-wrap {
  display: flex;
  margin-bottom: 20px;
}
</style>
